var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 47.273,
    viewBox: "0 0 48 47.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.742,
    y: 25.788,
    width: 13.818,
    height: 3.636,
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.742,
    y: 20.696,
    width: 13.818,
    height: 3.637,
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.742,
    y: 30.878,
    width: 13.818,
    height: 3.637,
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.941,10.947,13.866.061a.73.73,0,0,0-.761.112L.257,11.082,1.2,12.19,13.7,1.575,37.923,12.091V34.515h1.455v-22.9A.725.725,0,0,0,38.941,10.947Z",
    fill: "#525c6b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.03,10.183h5.091a.728.728,0,0,0,.7-.932L14.274.523a.727.727,0,0,0-1.4,0L10.333,9.251a.729.729,0,0,0,.7.932Zm2.546-6.858,1.576,5.4H12Z",
    fill: "#ffbd66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.789,15.489l-4.334-4.364a.724.724,0,0,0-.516-.215H34.457a.657.657,0,0,0-.234,0H.727a.727.727,0,0,0-.356,1.36l7.758,4.364a.715.715,0,0,0,.356.094H10.3V45.455a.729.729,0,0,0,.727.728h5.091a.727.727,0,0,0,.727-.728V16.728H47.272a.728.728,0,0,0,.517-1.239Zm-19.545-.216H23.027l2.609-2.607Zm-.853-2.909h5.171L29.976,14.95Zm6.95.278,2.631,2.631H31.71Zm1.778-.278h5.064L38.651,14.9ZM8.676,15.273,3.5,12.364H11.03a.727.727,0,0,0-.727.728v2.182H8.676Zm6.718,0H11.757V13.819h3.637Zm0,17.454H11.757V29.091h3.637Zm-3.636,1.455H15.4v3.637H11.758Zm3.636-6.546H11.757V24h3.637Zm0,17.091H11.757V39.273h3.637Zm0-22.181H11.757V16.728h3.637Zm.727-10.182H23.88l-2.91,2.909H16.848V13.091A.726.726,0,0,0,16.121,12.364Zm24.21,2.909,2.606-2.605,2.588,2.605Z",
    fill: "#ffbd66"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.3,8H10.667a2.182,2.182,0,0,0-2.182,2.183v7.271a.728.728,0,0,0,.728.728H17.94a.727.727,0,0,0,.728-.728V12.363A4.366,4.366,0,0,0,14.3,8Z",
    fill: "#7a8e9b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.719,9.82H10.655a.473.473,0,0,0-.473.473v3.568a.474.474,0,0,0,.473.474H16.5a.474.474,0,0,0,.474-.474V12.07A2.252,2.252,0,0,0,14.719,9.82Z",
    fill: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.576,43.637h-16a2.909,2.909,0,0,0-2.909,2.909v.727H24.485v-.727A2.909,2.909,0,0,0,21.576,43.637Z",
    fill: "#525c6b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrane);
export default __webpack_public_path__ + "static/media/crane.09202d88f51f3fbf0bff4407b8878682.svg";
export { ForwardRef as ReactComponent };